module.exports = __webpack_public_path__ + "img/map-GERMANY-en.240d9354.webp";